export default "__VITE_ASSET__BYh_peov__"